import { render } from "./Mine.vue?vue&type=template&id=30a48372"
import script from "./Mine.vue?vue&type=script&lang=js"
export * from "./Mine.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/buildings/Mine.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "30a48372"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('30a48372', __exports__)) {
    api.reload('30a48372', __exports__)
  }
  
  module.hot.accept("./Mine.vue?vue&type=template&id=30a48372", () => {
    api.rerender('30a48372', render)
  })

}


export default __exports__